export const CATEGORIES = [
  { value: "hombre", label: "Hombre" },
  { value: "mujer", label: "Mujer" },
  { value: "accesorios", label: "Accesorios" },
  { value: "gorras", label: "Gorras" },
  { value: "zapatos", label: "Zapatos" },
  { value: "nuevos", label: "Nuevos" },
  { value: "ofertas", label: "Liquidacion" },
];

export const EMPTY_FORM = {
  name: "",
  size: "S, M, L",
  brand: "",
  buy_price_usd: "",
  buy_price: "",
  retail_price: "",
  sale_price: "",
  image_url: "",
  images: [],
  category: "hombre",
  exclusive: false,
};

export const productSizes = (p) =>
  p.available_sizes?.length > 0 ? p.available_sizes : (p.size?.split(",").map(s => s.trim()).filter(Boolean) || []);

export const productProfit = (p) => (p.sale_price || 0) - (p.buy_price || 0);

export const getProductAge = (createdAt) => {
  if (!createdAt) return "";
  const days = Math.floor((Date.now() - new Date(createdAt)) / 86400000);
  if (days === 0) return "Hoy";
  if (days === 1) return "1 dia";
  if (days < 30) return `${days} dias`;
  const months = Math.floor(days / 30);
  return months === 1 ? "1 mes" : `${months} meses`;
};

export const getMonthlyReports = (soldProducts) => {
  const months = {};
  soldProducts.forEach(p => {
    const date = new Date(p.sold_at || p.created_at || Date.now());
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    if (!months[key]) {
      months[key] = { label: date.toLocaleDateString("es-MX", { month: "long", year: "numeric" }), products: [], revenue: 0, profit: 0, cost: 0 };
    }
    months[key].products.push(p);
    months[key].revenue += p.sale_price || 0;
    months[key].profit += productProfit(p);
    months[key].cost += p.buy_price || 0;
  });
  return Object.entries(months).sort(([a], [b]) => b.localeCompare(a)).map(([, v]) => v);
};

export const filterProducts = (products, { search, category, size, brand }) =>
  products.filter(p => {
    if (category && p.category !== category) return false;
    if (brand && p.brand?.trim() !== brand) return false;
    if (size && !productSizes(p).some(s => s.toUpperCase() === size)) return false;
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return p.name?.toLowerCase().includes(q) || p.brand?.toLowerCase().includes(q) || p.size?.toLowerCase().includes(q);
  });

export const formToProductPayload = (formData) => {
  const salePrice = parseFloat(formData.sale_price) || 0;
  const retailPrice = parseFloat(formData.retail_price) || 0;
  return {
    name: formData.name,
    size: formData.size,
    brand: formData.brand,
    buy_price: parseFloat(formData.buy_price) || 0,
    buy_price_usd: parseFloat(formData.buy_price_usd) || 0,
    retail_price: retailPrice,
    original_price: retailPrice || salePrice,
    sale_price: salePrice,
    image_url: formData.image_url,
    category: formData.category,
    images: formData.images || [],
    exclusive: formData.exclusive || false,
  };
};

export const productToForm = (product, toUSD) => {
  let usd = "";
  if (product.buy_price_usd > 0) usd = product.buy_price_usd.toString();
  else if (product.buy_price > 0) usd = toUSD(product.buy_price);
  return {
    name: product.name,
    size: product.size || "S, M, L",
    brand: product.brand || "",
    buy_price_usd: usd,
    buy_price: product.buy_price?.toString() || "",
    retail_price: product.retail_price?.toString() || "",
    sale_price: product.sale_price?.toString() || "",
    image_url: product.image_url || "",
    images: product.images?.filter(Boolean) || [],
    category: product.category || "hombre",
    exclusive: product.exclusive || false,
  };
};
